export const countriesWithRequiredStates = {
  US: {
    zipCode: '20001',
    state: 'DC',
  },
  CA: {
    zipCode: 'K1A 0A1',
    state: 'ON',
  },
  IN: {
    zipCode: '110001',
    state: 'DL',
  },
} as const;
